import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const falconData = LocalesData.falcon;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: falconData.roleExperSubTitle,
  driverName: falconData.driverName,
  driverType: falconData.driverType,
  driversSex: falconData.driversSex,
  driversBirthplace: falconData.driversBirthplace,
  driversStructure: falconData.driversStructure,
  driversRoleExperText: falconData.driversRoleExperText,
  mechaInfoType: falconData.mechaInfoType,
  mechaInfoNums: falconData.mechaInfoNums,
  mechaInfoHeadHigh: falconData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: falconData.mechaInfoEmptyWeight,
  mechaInfoTotal: falconData.mechaInfoTotal,
  mechaInfoStory: falconData.mechaInfoStory,
  manufacturerGruopCh: falconData.manufacturerGruopCh,
  cvCH: falconData.cvCH,
  cvEN: falconData.cvEN,
  cvJA: falconData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254409435_1-Vox_Pilot_Get_Elite_LeonieFevre.wav',
      title: falconData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254409435_2-Vox_Pilot_Entrance_Elite_LeonieFevre_a.wav',
      title: falconData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254409435_3-Vox_Pilot_MVP_Elite_LeonieFevre_a.wav',
      title: falconData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254367103_1-Vox_Pilot_Get_Elite_LeonieFevre.wav',
      title: falconData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254367103_2-Vox_Pilot_Entrance_Elite_LeonieFevre_a.wav',
      title: falconData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254367103_3-Vox_Pilot_MVP_Elite_LeonieFevre_a.wav',
      title: falconData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254239846_1-Vox_Pilot_Get_Elite_LeonieFevre.wav',
      title: falconData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254239846_2-Vox_Pilot_Entrance_Elite_LeonieFevre_a.wav',
      title: falconData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1751254239846_3-Vox_Pilot_MVP_Elite_LeonieFevre_a.wav',
      title: falconData.voice.title3,
      isPlay: false
    }
  ]
};
